<template>
    <div style="width:100%;">

        <nav>

            <v-app-bar color="indigo" dark fixed app>
                <v-app-bar-nav-icon class="grey--text" @click="drawer = !drawer"></v-app-bar-nav-icon>
                <v-toolbar-title class="text-uppercase grey--text">
                    <span class="font-weight-light">USERS</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>


                <v-btn  v-if="view == 'header'" text color="grey"
                    @click.prevent="newUser()">
                    <v-icon right>add_box</v-icon>
                </v-btn>

                <v-btn v-if="view == 'header'" text color="grey"
                    @click.prevent="refresh()">
                    <v-icon right>refresh</v-icon>
                </v-btn>

                <v-btn text color="grey"
                    @click.prevent="signOut">
                    <span></span>
                    <v-icon right>exit_to_app</v-icon>
                </v-btn>

            </v-app-bar> 

            <NavDraw :drawer="drawer" ></NavDraw>

        </nav>
        <v-container>

            <div v-if="view=='header'">

                <v-layout column>
                    
                    <v-flex v-for="(user,i) in users" :key="i">

                        <UserLine :user="user" @clickUser="viewDetail(user)"></UserLine>

                    </v-flex>

                </v-layout>

            </div>
            <div v-else-if="view=='detail'">
                <v-layout column>
                    <v-flex>
                        <UserDet :user="activeUser" :mode="detailMode" @close="closeUserDet"></UserDet>
                    </v-flex>
                </v-layout>
            </div>

        </v-container>

    </div>
</template>

<script>
import NavDraw from '@/components/NavDraw'
import {mapState, mapActions} from 'vuex'
//import DocFileDetail from './DocFileDetail'
import UserDet from './UserDet';
import UserLine from './UserLine';

const fb = require('../../firebaseConfig.js')

export default {
    components:{NavDraw,UserDet,UserLine},
    data(){
        return {
            drawer:false,
            view:"header",
            detailMode:'update',
            activeUser:null,
            users:[]
        }
    },
    computed:{
        ...mapState(['currentUser'])
    },
    methods:{
        ...mapActions([]),
        refresh(){
            //this.$store.dispatch('VIDEOS_GET');

            this.setUsers()

        },
        newUser(){
            this.view = "detail";
            this.activeUser = null
            this.detailMode = "new"
        },
        viewDetail(user){
            if (this.drawer){
                this.drawer = false
            }
            console.log("update user",user)
            this.view = "detail";
            this.activeUser = user;
            this.detailMode = "update"
        },
        closeUserDet(val){
            //console.log("val",val)
            
            this.view = 'header'
            if (val && val.email != ''){
                console.log(val.email)
                setTimeout(()=>{
                    this.fetchUsers();
                },2000)
                
            }

        },
        signOut(){

            let self = this;
            fb.auth.signOut().then(function() {
                self.$router.push({name:'Login'})
            }).catch(function(error) {
                // An error happened.
                console.log(error.message)
            });

        },
        setUsers(){

            this.users = []
            let users = []
            fb.usersCollection.get()
            .then(docs=>{

                docs.forEach(doc=>{
                    const  user = {
                        id:doc.id,
                        userID:doc.data().userID,
                        userName:doc.data().userName,
                        hdType:doc.data().hdType,
                        userType:doc.data().userType,
                        email:doc.data().email,
                        brand:doc.data().brand,
                        department:doc.data().department,
                        section:doc.data().section,
                        fileUrl:doc.data().fileUrl,
                        thumbUrl:doc.data().thumbUrl
                    }
                    users.push(user);
                });
                this.$store.state.users = [...users]
                this.users = [...users]
            });
        },
        async checkDropdownLists(){
        
            if (this.$store.state.brands.length == 0){
                let brands = []
                let b = await fb.brandsCollection.get()
                //console.log('b',b)
                for(const doc of b.docs){
                    brands.push(doc.data().brand);
                }
                this.$store.state.brands = [...brands]
                //console.log("this.brands",this.$store.state.brands)
            }

            if (this.$store.state.departments.length == 0){
                let departments = []
                let b = await fb.departmentsCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    departments.push({
                        id:doc.id,
                        department:doc.data().department,
                        hdType:doc.data().hdType
                    });
                }
                this.$store.state.departments = [...departments]
                //console.log("this.$store.state.departments",this.$store.state.departments)
            }

            if (this.$store.state.sections.length == 0){
                let sections = []
                let b = await fb.sectionsCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
					sections.push({
                        id:doc.id,
                        section:doc.data().section,
                        hdType:doc.data().hdType
                    });
                }
                this.$store.state.sections = [...sections]
                console.log("this.$store.state.sections",this.$store.state.sections)
            }


        }
    },
    mounted(){

        console.log("Users mounted!");
        //console.log("users",this.users)
        
    },
    created(){
        console.log("Users Created")
        this.headerView = true;

        if ( !this.$store.state.currentUser || this.$store.state.currentUser.userID == ''){

            let currentUser = JSON.parse(localStorage.getItem('currentUser'))

            if (currentUser){
                this.setCurrentUser(currentUser)
            }else{
                this.$router.push('/')
            }
            
        }

        this.checkDropdownLists()
        this.setUsers()

        console.log("this.$store.state.currentUser",this.$store.state.currentUser)


    },

}
</script>

<style  scoped>

.row-header .col-header {
    background-color:black;
    color:white;
    font-weight: bold;
    text-align: center;
    padding-bottom: 5px;
    padding-top: 5px;
    margin-top: 10px;
    margin-bottom: 5px;
}

.row-header .col-header2 {
    background-color:lightgray;
    color:black;
    font-weight: bold;
    font-size:medium;
    text-align: center;
}

.file-icon{
    width:40px;
    height: 40px;
    max-width: 40px;
    max-height: 40px;
}

.dv-clear{
    cursor: pointer;
}
.label-text{
    font-weight: bold;
}
.dv-message{
    font-weight: bold;
    font-size: 1.2rem;
    color:blue;
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.errorMessage{
    color:red;
    border: 2px solid red;
    padding: 10px;
}

.emp-clear-status{
    color:blue;
    border: 2px solid red;
    font-weight: bold;
    padding: 5px;
}
</style>